var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("i", { class: _vm.icon }),
      _vm.title
        ? _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e()
    ]),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "type" }, [_vm._v(_vm._s(_vm.cardType))]),
      _c("div", { staticClass: "total" }, [
        _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.value))]),
        _c("div", { staticClass: "subValue" }, [_vm._v("cadastros")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a61de6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a61de6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/components/Card.vue
// module id = null
// module chunks = 